import React, { useEffect, useState } from "react";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import TeamService from "services/TeamService";
import TimeFilter from "components/TimeFilter";
import SlideshowStatsDetailsCard from "./SlideshowStatsDetailsCard";
import MainPageSlideshowStatsDetailsCard from "./MainPageSlideshowStatsDetailsCard";
import Scrollbar from "react-scrollbars-custom";

const styles = {
  detailsContainer: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  loadMoreButton: {
    textAlign: "center",
  },
  timeFilter: {
    height: "35px",
  },
  detailCardContainer: {
    display: "flex",
    flex: 1,
    overflow: "auto",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ showSlideshow, opened, team_id, time, setTime }) => {
  const classes = styles;
  const [loading, setLoading] = useState(true);
  const [slideShows, setSlideShows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState("");

  useEffect(() => {
    if (!opened) {
      setSlideShows([]);
      setPage(1);
      setLoading(true);
      return;
    }

    (async () => {
      setLoading(true);

      try {
        const response = await TeamService.getSlideshowStatsDetails(
          team_id,
          time,
          page
        );

        setSlideShows(
          Array.from(new Set([...slideShows, ...response.data.data]))
        );

        setTotal(response?.data?.total);
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    })();

    // eslint-disable-next-line
  }, [opened, team_id, page, time]);

  if (!opened) {
    return <Loader loaderStyle={classes.loaderStyle} />;
  }

  const updateTime = (updatedTime) => {
    setSlideShows([]);
    setTime(updatedTime);
    setPage(1);
  };

  const getNextPageData = () => {
    setLoading(true);
    setPage(page + 1);
  };

  const LoadingContainer = (
    <>
      {loading && (
        <h4 style={{ display: "flex", justifyContent: "center" }}>
          <Loader loaderStyle={classes.LoaderStyle} />
        </h4>
      )}
      {!loading && total !== slideShows.length && (
        <h4>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  return (
    <div style={classes.detailsContainer}>
      <div style={classes.timeFilter}>
        <TimeFilter time={time} setTime={updateTime} color={"black"} />
      </div>
      <div style={classes.detailCardContainer}>
        <Scrollbar>
          {showSlideshow &&
            slideShows.map((slideShow) => (
              <SlideshowStatsDetailsCard
                key={slideShows.id}
                slideShow={slideShow}
              />
            ))}
          {!showSlideshow &&
            slideShows.map((slideShow) => (
              <MainPageSlideshowStatsDetailsCard
                key={slideShow.id}
                slideShow={slideShow}
              />
            ))}
          {LoadingContainer}
        </Scrollbar>
      </div>
    </div>
  );
};
